import { AccountPageProps } from 'models/AccountPageProps';
import { CategoryPageProps } from 'models/CategoryPageProps';

export const emptyPage: CategoryPageProps | AccountPageProps = {
  categoryList: [],
  metadata: {
    totalShopCount: 0,
    totalPageCount: 0
  },
  queryParams: {},
  shops: [],
  category: null,
  searchTerm: '',
  activePage: null,
  sort: '',
  hasValidCertificate: false
};
